import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Carousel from '../Carousel/Carousel';
import { DISCIPLINES_TO_SLIDE } from './DisciplineSlider.helper';
import classNames from 'classnames';

import css from './DisciplineSlider.module.css';

const DisciplineSlider = props => {
  const { className } = props;

  // ✅ SEO IMPROVEMENT: Get locale from Redux state (SSR-compatible)
  const { interfaceLang } = useSelector(state => state.ui);
  const locale = interfaceLang; // e.g., 'en-US'
  
  // Map locale to SEO activity page base path
  const seoActivityBasePaths = {
    'en-US': 'outdoor-activities',
    'de-DE': 'outdoor-aktivitaeten',
    'fr-FR': 'activites-outdoor',
    'it-IT': 'attivita-outdoor',
  };
  
  const basePath = seoActivityBasePaths[locale] || 'outdoor-activities';

  return (
    <div data-carousel-wrapper="discipline-slider">
    <Carousel
      className={classNames(css.root, className)}
      contentClassName={css.carouselContent}
      columns={6}
    >
      {DISCIPLINES_TO_SLIDE.map(discipline => {
        // Get the appropriate slug for current locale, fallback to English or key
        const slug = discipline.seoSlugs?.[locale] || discipline.seoSlugs?.['en-US'] || discipline.key.toLowerCase();
        
        // Construct the full path: /{locale}/{basePath}/{slug}
        const activityPath = `/${locale}/${basePath}/${slug}`;
        
        return (
          <Link
            key={discipline.key}
            to={activityPath}
            className={css.card}
          >
            <div className={css.imageWrapper}>
              <div className={css.aspectWrapper}>
                <img
                  src={discipline.srcImg}
                  alt={discipline.key}
                  className={css.disciplineImage}
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>
            <div className={css.wrapper}>
              <FormattedMessage id={`General.${discipline.key}`} />
            </div>
          </Link>
        );
      })}
    </Carousel>
    </div>
  );
};

export default DisciplineSlider;
